import React from 'react';
import { Layout } from 'antd';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';

const PageLayout = ({ children, fullWidthContent }) => {
  return (
    <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#F5F5F5' }}>
      <Header />
      <Layout.Content style={{ flex: '1 0 auto', display: 'flex', flexDirection: 'column', marginTop: '100px' }}>
        <div style={{ position: 'relative' }}>
          {fullWidthContent}
        </div>
        <div style={{ maxWidth: '1200px', width: '100%', margin: '0 auto', padding: '0 16px' }}>
          {children}
        </div>
      </Layout.Content>
      <Footer />
    </Layout>
  );
};

export default PageLayout;
